// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__juMUx","noPadding":"style_noPadding__tGa9N","padding25":"style_padding25__iHo2y"};